import { toast } from 'react-toastify';

export interface FormError {
    field: string;
    message: string;
}

export interface GlobalError {
    message: string;
}

interface ErrorsRecord {
    formErrors: FormError[];
    globalErrors: GlobalError[];
}

export default class Errors implements ErrorsRecord {
    constructor(formErrors: FormError[], globalErrors: GlobalError[]) {
        this.formErrors = formErrors;
        this.globalErrors = globalErrors;
    }

    containsFormErrors = () => {
        return this.formErrors.length > 0;
    };

    formErrors: FormError[];
    globalErrors: GlobalError[];
}

export interface ErrorDetails {
    field: string;
    messageCode: string;
    messageParams: string[];
}

export const handleGlobalErrors = (errors: string[]) =>
    errors.forEach((message: string) => toast.error(message));
